import { Dispatch } from 'redux';
import * as actions from './actionCatalog';
import defaultDebounce from './debouncer';
import * as http from '../http';

import { Encodings, ForwardRule, Node } from '../reducers/nodesReducer';

const regularGetNodes = (dispatch: Dispatch) => http.get<Node[]>(actions.GET_NODES, dispatch);
const debouncedGetNodes = defaultDebounce(regularGetNodes);

const regularGetNodesEncodings = (dispatch: Dispatch) => http.get<Encodings>(actions.GET_NODES_ENCODINGS, dispatch);
const debouncedGetNodesEncodings = defaultDebounce(regularGetNodesEncodings);

const regularGetForwardRules = (dispatch: Dispatch) => http.get<ForwardRule[]>(actions.GET_FORWARD_RULES, dispatch);
const debouncedGetForwardRules = defaultDebounce(regularGetForwardRules);

export const getNodes = () => debouncedGetNodes;
export const forceGetNodes = () => regularGetNodes;

export const getNodesEncodings = () => debouncedGetNodesEncodings;
export const forceGetNodesEncodings = () => regularGetNodesEncodings;

export const getForwardRules = () => debouncedGetForwardRules;
export const forceGetForwardRules = () => regularGetForwardRules;

export function updateNode(node: Node) {
  return http.post<void>(actions.UPDATE_NODE, node);
}

export function insertNode(node: Node) {
  return http.post<void>(actions.INSERT_NODE, node);
}

export function dicomEcho(node: Node) {
  return http.post<string>(actions.DICOM_ECHO, node);
}

export function insertForwardRule(rule: ForwardRule) {
  return http.post<void>(actions.FORWARD_RULES, rule);
}

export function updateForwardRule(rule: ForwardRule) {
  return http.put<void>(actions.FORWARD_RULES, rule);
}

export function deleteForwardRule(rule: { source: number; destination: number }) {
  return http.del<void>(actions.FORWARD_RULES, rule);
}

export function restartServices() {
  return http.get<boolean>(actions.RESTART_SERVICES);
}

export function isTouchedNode() {
  return {
    type: actions.IS_LAST_TOUCHED_NODE,
  };
}

export function isTouchedRule() {
  return {
    type: actions.IS_LAST_TOUCHED_RULE,
  };
}

export function disableNode(node: Node) {
  return http.post<void>(actions.DISABLE_NODE, { pk: node.pk });
}
